/* eslint-disable react/jsx-no-duplicate-props */
import React from 'react'
import { NavItem } from 'reactstrap';
import { NavLink, useLocation } from 'react-router-dom'
import { useHistory } from 'react-router'
import { If, Then, Else, Switch, Case, Default } from 'react-if'
import classNames from 'classnames'
import { useTranslation } from 'react-i18next'
import i18next from 'i18next'
import cookies from 'js-cookie'

// import { HiMenu, HiX } from "react-icons/hi"
// import { FaCog, FaGlobeAsia, FaThLarge, FaRegCalendarAlt, FaRegCalendarCheck, FaRegCalendarPlus, FaRegCalendar, FaEllipsisV, FaSignOutAlt  } from "react-icons/fa"
import { FaCog, FaGlobeAsia, FaEllipsisV, FaSignOutAlt  } from "react-icons/fa"

import { BsLayoutSidebarInset,BsLayoutSidebar } from "react-icons/bs";
import { FcHome,FcPlanner,FcCalendar,FcInspection,FcLeave,FcMoneyTransfer,FcAlarmClock } from "react-icons/fc";


// redux
import { updateProfile } from './redux/actions/authAction'
import { useSelector, useDispatch } from 'react-redux'
import languages from '../config/languages'
// import useHover from '../hooks/useHover';


// Hide Dropdown on Outside Click
let useClickOutside = (handler) => {
    let domNode = React.useRef();

    React.useEffect(() => {
        let maybeHandler = (event) => {
            if (!domNode.current.contains(event.target)) {
                handler();
            }
        };
        document.addEventListener("mousedown", maybeHandler);

        return () => {
            document.removeEventListener("mousedown", maybeHandler);
        };
    });
    return domNode;
};



const NavBar = () => {
    const currentLanguageCode = cookies.get('i18next') || 'en'
    const currentLanguage = languages.find((l) => l.code === currentLanguageCode)
    const { t } = useTranslation()

    // const [hover, attrs] = useHover()
    // console.log(hover, attrs)
    const [collapse, setCollapse] = React.useState(true)
    const [isOpen, setIsOpen] = React.useState(false);
    const [isOpen2, setIsOpen2] = React.useState(false);

    const { pathname } = useLocation()
    // const currentPage = pathname.split("/").pop()
    const currentPage = pathname.split("/")[1] // only index 1 no need after / 


    const history = useHistory()
    const dispatch = useDispatch()

    const profileRedux = useSelector(state => state.authReducer.profile)

    const toggling = () => setIsOpen(!isOpen)
    const toggling2 = () => setIsOpen2(!isOpen2)
    // ----------- Hide dropdown -----------------
    // Hide Dropdown on Outside Click
    let domNode = useClickOutside(() => {
        setIsOpen(false);
    });
    let domNode2 = useClickOutside(() => {
        setIsOpen2(false);
    });
    // ----------- Hide dropdown -----------------

    const logout = () => {
        localStorage.removeItem('token')
        localStorage.removeItem('profile')
        history.replace("/")
        history.go("/")
        dispatch(updateProfile(null))
    }

    //redux 
    const getProfile = () => {
        const profileValue = JSON.parse(localStorage.getItem("profile"))
        if (profileValue) {
            dispatch(updateProfile(profileValue))
        }
    }

    const checkIsRequestsUrl = () => {
        if (currentPage === 'approve') {
            if (profileRedux) {
                if (JSON.parse(localStorage.getItem("profile")).APPROVE_PERSON === '1') {
                    history.replace("/approve")
                }
                else {
                    history.replace("/leave")
                }
            }
        }
    }



    React.useEffect(() => {

        document.body.dir = currentLanguage.dir || 'ltr'
        // document.title = t('app_title')
        getProfile()
        checkIsRequestsUrl()
        // ----------- resize screen -----------------
        const handleResize = () => {
            if (window.innerWidth < 1200) {
                setCollapse(false)
            } else {
                setCollapse(true)

            }
        }
        window.addEventListener('resize', handleResize)
        // ----------- resize screen -----------------

        return () => {
            window.removeEventListener("resize", handleResize);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentLanguage, t, isOpen, isOpen2])

    return (
        <>
            <nav className={collapse ? "sidebar" : "sidebar close"} >
                <header>
                    <NavLink to="/dashboard" >
                        <div className="image-text">
                            <span className="image">
                                <i className="pt-2 sml-icon-simlexicon icon" style={{ fontSize: '40px' }}></i>
                            </span>
                            <div className="text logo-text">
                                <span className="pt-2 name">Simlex</span>
                                <span className="profession">Leave Online</span>
                            </div>
                        </div>
                    </NavLink>
                </header>

                <div className="menu-bar">
                    <div className="menu">
                        <ul className="pt-5 menu-links">
                            <NavItem className={(pathname.indexOf("/dashboard") > -1) ? "nav-link active" : "nav-link"} >
                                <NavLink to="/dashboard" exact={true}>
                                    {/* <i className='fas fa-th-large icon'></i> */}
                                    <FcHome className='icon'/>
                                    <span className="text nav-text">{t("t_dashboard")}</span>
                                </NavLink>
                            </NavItem>
                            <NavItem className={(pathname.indexOf("/calendar") > -1) ? "nav-link active" : "nav-link"} >
                                <NavLink to="/calendar" >
                                    {/* <i className='fas fa-calendar icon'></i> */}
                                    <FcCalendar className='icon'/>

                                    <span className="text nav-text">{t("t_calendar")}</span>
                                </NavLink>
                            </NavItem>
                            <NavItem className={(pathname.indexOf("/request") > -1) ? "nav-link active" : "nav-link"} >
                                <NavLink to="/request" >
                                    {/* <i className='fas fa-calendar-plus icon'></i> */}
                                    <FcPlanner className='icon'/>

                                    <span className="text nav-text">{t("t_leaveRequest")}</span>
                                </NavLink>
                            </NavItem>

                            {/* Dot show Menubar Approve Not Admin user */}
                            {profileRedux ? (
                                <If condition={profileRedux.APPROVE_PERSON === "1"}>
                                    <Then>
                                        <NavItem className={(pathname.indexOf("/approve") > -1) ? "nav-link active" : "nav-link"} >
                                            <NavLink to="/approve" >
                                                {/* <i className='fas fa-calendar-check icon'></i> */}
                                                <FcInspection className='icon'/>
                                                <span className="text nav-text">{t("t_approveList")}</span>
                                            </NavLink>
                                        </NavItem>
                                    </Then>
                                </If>
                            ) : (
                                <></>
                            )

                            }

                            <NavItem className={(pathname.indexOf("/leave") > -1) ? "nav-link active" : "nav-link"} >
                                <NavLink to="/leave" >
                                    {/* <i className='fas fa-calendar-alt icon'></i> */}
                                    <FcLeave className='icon'/>
                                    <span className="text nav-text">{t("t_leaveList")}</span>
                                </NavLink>
                            </NavItem>


                            <NavItem className={(pathname.indexOf("/salary") > -1) ? "nav-link active" : "nav-link"} >
                                <NavLink to="/salary" >
                                    {/* <i className='fas fa-calendar-alt icon'></i> */}
                                    <FcMoneyTransfer className='icon'/>
                                    <span className="text nav-text">{t("t_salary")}</span>
                                </NavLink>
                            </NavItem>

                            {/* <NavItem className={(pathname.indexOf("/check-in") > -1) ? "nav-link active" : "nav-link"} >
                                <NavLink to="/check-in" >
                                    <FcAlarmClock className='icon'/>
                                    <span className="text nav-text">{t("t_salary")}</span>
                                </NavLink>
                            </NavItem> */}


                        </ul>
                    </div>

                    {/* <div className="bottom-content">
                        <NavItem  >
                            <NavLink to="/logout" onClick={logout}>
                                <i class='fas fa-sign-out-alt icon'></i>
                                <span class="text nav-text">Logout</span>
                            </NavLink>
                        </NavItem>
                    </div> */}

                </div>
            </nav>
            
            {/* nav bar top */}
            <nav className="navigation-top">
                <div className="sidebar-button">
                    <div className="d-flex justify-content-start">
                        <If condition={collapse}>
                            <Then>
                                <BsLayoutSidebarInset className='toggle-menu' onClick={() => { setCollapse(!collapse) }} />
                            </Then>
                            <Else>
                                <BsLayoutSidebar className='toggle-menu' onClick={() => { setCollapse(!collapse) }} />
                            </Else>
                            {/* <Then>
                                <HiMenu className='toggle-menu' onClick={() => { setCollapse(!collapse) }} />
                            </Then> */}
                        </If>
                        {/* <i className="fas fa-bars toggle-menu" onClick={() => { setCollapse(!collapse) }}></i> */}
                        <span className="title-main ms-2">
                            <Switch>
                                <Case condition={currentPage === 'dashboard'}>  {t("t_dashboard")} </Case>
                                <Case condition={currentPage === 'calendar'}>  {t("t_calendar")} </Case>
                                <Case condition={currentPage === 'request'}>  {t("t_leaveRequest")} </Case>
                                <Case condition={currentPage === 'approve'}>  {t("t_approveList")} </Case>
                                <Case condition={currentPage === 'leave'}>  {t("t_leaveList")} </Case>
                                <Case condition={currentPage === 'settings'}>  {t("b_settings")} </Case>
                                <Case condition={currentPage === 'salary'}>  {t("t_salary")} </Case>
                                <Case condition={currentPage === 'check-in'}>  {t("t_salary")} </Case>

                                <Default>{currentPage}</Default>
                            </Switch>
                        </span>
                    </div>
                </div>
                {/* Header Bar */}
                <div className="sidebar-button-right">

                    <div className="login-text me-2">
                        {/* <i className="fas fa-user-tie"></i> */}
                        <span className="title-main">
                            {profileRedux ? (
                                profileRedux.FIRST_NM
                            ) : (
                                <></>
                            )
                            }</span>
                    </div>

                    {/* Chang Languages */}

                    <div className="EventOutside">
                        <div onClick={toggling2} className={`dropdown-right ${isOpen2 ? "show" : ""}`} style={{ marginRight: '1rem' }} ref={domNode2}>
                            <FaGlobeAsia />
                            <div className="dropdown-right-content">

                                <div className="dropdown-container">
                                    <div className="dropdown-item disabled" >
                                        <span className="dropdown-item-text">{t('t_language')}</span>
                                    </div>
                                    {languages.map(({ code, name, country_code }) => (
                                        <div key={country_code}
                                            className={classNames('dropdown-item', {
                                                disabled: currentLanguageCode === code,
                                            })}
                                            onClick={() => {
                                                i18next.changeLanguage(code)
                                            }}
                                        >
                                            <span
                                                className={`fi fi-${country_code} mx-2`}
                                                style={{
                                                    opacity: currentLanguageCode === code ? 0.5 : 1,
                                                }}
                                            ></span>
                                            {name}
                                        </div>
                                    ))}
                                </div>

                            </div>
                        </div>


                        {/* User Setting // LogOut */}

                        <div onClick={toggling} className={`dropdown-right ${isOpen ? "show" : ""}`} ref={domNode}>
                            {/* <i className="fas fa-ellipsis-v toggle-menu"></i> */}
                            <FaEllipsisV className='icon'/>
                            <div className="dropdown-right-content">
                                <div className="dropdown-container">
                                    <NavLink className="dropdown-item" to="/settings">
                                        <FaCog /> {' '}
                                        <span className="text nav-text">{t("b_settings")}</span>
                                    </NavLink>
                                    <NavLink className="dropdown-item" to="/logout" onClick={logout}>
                                        <FaSignOutAlt /> {' '}
                                        <span className="text nav-text">{t("b_logout")}</span>
                                    </NavLink>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
                {/* Header Bar */}
            </nav>
            {/* nav bar top */}                                   
        </>
    )
}

export default NavBar